/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Property } from 'csstype';

const COLORS: Record<string, Property.Color> = {
  Background: '#096ba8',
  HeaderStepBorder: '#98a7bf',
  SectionBorderColor: '#d9d9d9',
  DividerColor: '#eaecf0',
  DividerBlueColor: '#72b7e4',
  GreyDashboardColor: '#f5f6fa',
  RedCardColor: '#fde8e8',
  OrangeCardColor: '#ffe8d2',
};

export default COLORS;
